import { createClient } from '@supabase/supabase-js';

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    'Missing Supabase environment variables. Please check your .env file.\n' +
    'Required variables:\n' +
    '  - VITE_SUPABASE_URL\n' +
    '  - VITE_SUPABASE_ANON_KEY'
  );
}

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});

// Generate a unique client ID for this browser session
// This replaces the socket ID from the old implementation
export const getClientId = () => {
  let clientId = sessionStorage.getItem('planning-poker-client-id');

  if (!clientId) {
    // Generate a unique ID: timestamp + random string
    clientId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    sessionStorage.setItem('planning-poker-client-id', clientId);
  }

  return clientId;
};

// Generate a unique 6-character session code
export const generateSessionCode = () => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
};

// Validate vote value
export const isValidVote = (vote) => {
  const validVotes = ['0', '1', '2', '3', '5', '8', '13', '21', '34', '55', '?', '☕'];
  return validVotes.includes(vote);
};
